import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------
const initialState = {
  isLoading: false,
  error: false,
  openDashboardMailCompose: false,
  communication: {
    user_certification: {},
    isLoading: false,
  },
  myTasks: {
    forceUpdate: false,
    isLoading: false,
    openInviteCertification: false,
    certification: {},
  },
  notice: {
    forceUpdate: false,
    isLoading: false,
    openCertificationNotice: false,
    task: {},
  },
  documentManagerTasks: {
    selectedTask: null,
    fileTaskIndex: null,
    tasksList: [],
    shouldReselect: false,
  },
  requestSignaturesTasks: {
    selectedTask: null,
    tasksList: [],
    openSignatures: false,
  },
};

const slice = createSlice({
  name: 'UserDashboard',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET CERTIFICATION FOR COMMUNICATION
    setCertification(state, action) {
      state.communication = {
        ...state.communication,
        user_certification: action.payload,
      };
    },

    // GET HOUSEHOLD DATA FOR INVITE CERTIFICATION
    setCertificationData(state, action) {
      state.myTasks = {
        ...state.myTasks,
        certification: action.payload,
        openInviteCertification: true,
      };
    },

    // GET DATA FOR CERTIFICATION NOTICE
    setCertificationNoticeTask(state, action) {
      state.notice = {
        ...state.myTasks,
        task: action.payload,
        openCertificationNotice: true,
      };
    },

    // CLEAR HOUSEHOLD DATA FOR INVITE CERTIFICATION
    clearCertificationData(state) {
      state.myTasks = {
        ...state.myTasks,
        certification: null,
        openInviteCertification: false,
      };
    },

    // CLEAR CERTIFICATION NOTICE
    clearCertificationNoticeTask(state) {
      state.notice = {
        ...state.myTasks,
        task: null,
        openCertificationNotice: false,
      };
    },

    // SET SELECTED TASK
    setSelectedTask(state, action) {
      state.documentManagerTasks = {
        ...state.documentManagerTasks,
        selectedTask: action.payload,
        tasksList: action.payload?.tasks,
      };
    },

    setFileTaskIndex(state, action) {
      state.documentManagerTasks.fileTaskIndex = action.payload;
    },

    setOpenRequestSignatures(state, action) {
      state.requestSignaturesTasks = {
        ...state.requestSignaturesTasks,
        selectedTask: action.payload,
        tasksList: action.payload?.tasks,
        openRequestSignatures: true,
      };
    },

    setShouldReselect(state, action) {
      state.documentManagerTasks = {
        ...state.documentManagerTasks,
        shouldReselect: action.payload,
      };
    },

    clearOpenRequestSignatures(state) {
      state.requestSignaturesTasks = {
        ...state.requestSignaturesTasks,
        selectedTask: null,
        tasksList: [],
        openRequestSignatures: false,
      };
    },

    // SET SELECTED TASK
    cleanTasks(state) {
      state.documentManagerTasks = {
        ...state.documentManagerTasks,
        selectedTask: null,
        tasksList: [],
      };
    },

    setForceUpdate(state, action) {
      state.myTasks = {
        ...state.myTasks,
        forceUpdate: action.payload,
      };
    },

    setOpenDashboardMailCompose(state, action) {
      state.openDashboardMailCompose = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  setCertification,
  setOpenDashboardMailCompose,
  setSelectedTask,
  setFileTaskIndex,
  setForceUpdate,
  setOpenRequestSignatures,
  clearOpenRequestSignatures,
  setCertificationData,
  setCertificationNoticeTask,
  clearCertificationData,
  clearCertificationNoticeTask,
} = slice.actions;
